export const data = [
        {
          category: 'certification',
          authority: 'AWS ',
          title: "AWS Machine Learning",

          image: '1.png',
          date: "May 2020"
     }, 
      {
          category: 'design',
          title: "ui/ux design",
          tools: "Adobe XD",
          image: 'ui.png',
          date: "April 2020"
     },
    {
          category: 'certification',
          authority: 'coursera ',
          title:'Artificial Intelligence for everyone',
          image: 'ai.jpg',
          date: "April 2019"
     },

     {
          category: 'certification',
          title:'Convolutional Neural Networks with Tensorflow',
          authority: 'Coursera',
          image: '3.png',
          date: "May 2019"
     },
     {
          category: 'certification',
          authority: 'Microsoft',
          title:"Mta python programming",
          date:"2017",
          image: 'c1.png',
     }
     ,
     {
          category: 'certification',
          authority: 'ML GDG Monastir',
          image: 'gd.jpg',
          date: "2019"
     },
     
     {
          category: 'Artificial Intelligence',
          title: ' Handwritten diagramm recognition using DNN ',
          tools: 'Python , Tensorflow , Image processing , FASTER R-CNN',
          image: '4.png',
          date: " from feb 2019 to Aug 2019 "
     },
     ,
     {
          category: 'Artificial Intelligence',
          title: ' Text extrator app',
          tools: 'Python ,Ionic , TesseractJS ',
          image: '22.png',
          date: " Mars 2019 "
     },

     {
          category: 'Artificial Intelligence',
          authority: 'AWS ',
          title: "Pointing system based face recognition",

          image: 'pointing.jpg',
          date: "Oct-Dec 2018"
     }, 
     {
          category: 'certification',
          title:'MTA software developpement fundamentals',
          authority: 'Microsoft',
          image: 'c2.png',
     }
     ,
      
     {
          category: 'certification',
          title: ' CybersecurityOps ',
          authority: 'CISCO',
          image: '2.png',
          date: "Jan 2019 "
     },

     {
          category: 'certification',
          title: "Devops ",
          authority: 'Udemy',
          image: 'devops.jpg',
     }
     ,

     {
          category: 'SAP',
          title: ' Clinical management system ',
          tools: 'JavaFX , JasperReport , Sqlite',
          image: 'a1.png',
          date: " 2018 "
     }
     ,
     {
          category: 'web',
          title: ' E-commerce website ',
          tools: 'Prestashop , PHP , mysql',
          image: 'zd.png',
          date: " 2018 "
     }
     

   ];


// WEBPACK FOOTER //
// ./src/components/data/WorksData.js